module.exports = __webpack_public_path__ + "img/icon_green.4d02aa4c.png";